// FE-SCRM-060 — <TagsCell> read-only chip list for table cells.
//
// Example:
//
//     // Inside a row in the Prospects table
//     <td><TagsCell tags={prospect.tags} max={3} /></td>
//
// Pairs with <TagsInput> (the editable surface). Renders nothing
// for an empty list so the cell collapses to "—" or whatever the
// host table chooses.

const DEFAULT_MAX = 4;


export interface TagsCellProps {
  tags: readonly string[];
  /** Max chips to render before collapsing to a +N overflow. */
  max?: number;
  className?: string;
}


export function TagsCell({
  tags, max = DEFAULT_MAX, className,
}: TagsCellProps): JSX.Element | null {
  if (tags.length === 0) return null;

  const shown = tags.slice(0, max);
  const hidden = tags.slice(max);

  return (
    <div
      className={
        "inline-flex flex-wrap items-center gap-1 "
        + (className ?? "")
      }
    >
      {shown.map((t) => (
        <span
          key={t}
          className={
            "rounded-full bg-gray-100 px-2 py-0.5 text-xs "
            + "font-medium text-gray-700"
          }
        >
          {t}
        </span>
      ))}
      {hidden.length > 0 && (
        <span
          title={hidden.join(", ")}
          className={
            "rounded-full bg-gray-50 px-2 py-0.5 text-xs "
            + "font-medium text-gray-500"
          }
        >
          +{hidden.length}
        </span>
      )}
    </div>
  );
}
